import { render, staticRenderFns } from "./SubmitedInfoNotifyModal.vue?vue&type=template&id=767d70e6&scoped=true&"
import script from "./SubmitedInfoNotifyModal.vue?vue&type=script&lang=js&"
export * from "./SubmitedInfoNotifyModal.vue?vue&type=script&lang=js&"
import style0 from "./SubmitedInfoNotifyModal.vue?vue&type=style&index=0&id=767d70e6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "767d70e6",
  null
  
)

export default component.exports